import { ModalAlertaService } from './../shared/modal-alerta.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatRadioChange } from '@angular/material/radio';
import { catchError, take, tap } from 'rxjs/operators';
import { EMPTY, Observable, Subject, timer } from 'rxjs';
import { Component, OnInit, ViewChild } from '@angular/core';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAjudaService } from '../shared/modal-ajuda.service';
import { EnderecoEmail } from '../_classes/endereco-email';
import { EnvService } from '../_servicos/env.service';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';

@Component({
  selector: 'app-endereco-email',
  templateUrl: './endereco-email.component.html',
  styleUrls: ['./endereco-email.component.scss'],
})
export class EnderecoEmailComponent implements OnInit {
  private readonly recurso: string = 'endereco-email'; //mesmo que a rota
  carregando = false;
  displayedColumns: string[] = ['nome', 'descricao', 'auxiliar', 'tipo'];

  //servidor$: Observable<Servidor>;
  //servidor: Servidor = new Servidor();

  tipoEmail: string = 'T';
  filtro: string = '';

  erros$ = new Subject<boolean>();
  dataSource$: Observable<EnderecoEmail[]>;
  dataSource: MatTableDataSource<EnderecoEmail>;
  dataSourceOriginal: MatTableDataSource<EnderecoEmail>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  itensAjuda = [
    {
      titulo: 'Nome',
      texto:
        "Nome do endereço de email, para enviar mensagem adicione '@trt24.jus.br'",
    },
    {
      titulo: 'Descrição',
      texto: 'Descritivo do item',
    },
    {
      titulo: 'Auxiliar',
      texto:
        'Indica (nos endereços institucionais) se aquele é auxiliar da lotação',
    },
    {
      titulo: 'Tipo',
      texto:
        "Tipo de endereço listado, sendo 'L' listas de endereços de email, 'F' endereços funcionais das pessoas e 'I' endereço de email das localidades",
    },
  ];

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private ajudaService: ModalAjudaService,
    private env: EnvService
  ) {
    this.dataSourceOriginal = new MatTableDataSource<EnderecoEmail>();
    this.dataSource = new MatTableDataSource<EnderecoEmail>();
  }

  ngOnInit() {
    this.atualizar();
  }
  /*
  executarAoCarregarServidor(x: Servidor) {
    this.servidor = new Servidor(x);
  }*/

  executarAoCarregarDatasource(x: EnderecoEmail[]) {
    this.dataSource = new MatTableDataSource<EnderecoEmail>(x);
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
    }

    this.carregando = false;
  }

  filtrarTipo(e: MatRadioChange) {
    //console.log('evento', e);
    const filterValue = e.source.value;

    this.carregando = true;
    this.executarAoCarregarDatasource(
      this.dataSourceOriginal.data.slice().filter((d: EnderecoEmail) => {
        if (filterValue === 'T') {
          return true;
        }
        return d.tipo === filterValue;
      })
    );
    this.filtrar();
  }

  sortingDataAccessor(item, property) {
    if (property.includes('.')) {
      return property.split('.').reduce((object, key) => object[key], item);
    }
    return item[property];
  }

  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );

    this.dataSource$ = this.service.listarEnderecoEmail('T').pipe(
      tap((a) => {
        this.executarAoCarregarDatasource(a);
        this.dataSourceOriginal = new MatTableDataSource<EnderecoEmail>(a);
      }),
      take(1),
      catchError((e) => {
        this.handleError(e);
        return EMPTY;
      })
    );
  }

  /*
  atualizarOld() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError('Excedido tempo de carregamento');
      }
    });
    this.servidor =
      this.servService.getServidorAtualRedirecionando('endereco-email');

    this.servidor$ = this.servService.getServidor().pipe(
      tap((x) => this.executarAoCarregarServidor(x)),
      take(1),
      catchError((e) => {
        this.handleError(e);
        return empty();
      })
    );

    this.dataSource$ = this.service.listarEnderecoEmail('T').pipe(
      tap((a) => {
        this.executarAoCarregarDatasource(a);
        this.dataSourceOriginal = new MatTableDataSource<EnderecoEmail>(a);
      }),
      take(1),
      catchError((e) => {
        this.handleError(e);
        return empty();
      })
    );
  }*/

  aplicarFiltro(event: Event) {
    this.filtro = (event.target as HTMLInputElement).value;
    this.filtrar();
  }

  filtrar() {
    //console.log(this.filtro);

    this.dataSource.filter = this.filtro.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  mostrarAjudaModal() {
    this.ajudaService.mostrar(this.itensAjuda, '');
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
